import * as React from "react";
import Component from "../../AbstractComponent";

import { PromptDialog } from "./PromptDialog";
import { DatePickerComponent } from "../DatePicker/DatePickerComponent";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import { FinancialStatementInterface } from "Casadesk/Entity/Entities/FinancialStatement/FinancialStatementInterface";

import Time from "../../../Time/Time";
import Constants from "../../../Action/Constants";


export class SnoozeDialog extends Component {
  protected timer;

  public state = {
    entity: null,
    isOpen: false,
    snoozeDateForEntity: Time.weekFromDate(new Date())
  };

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.entity !== this.state.entity) {
      this.setState({
        entity: nextProps.entity
      });
    }

    if (nextProps.isOpen !== this.state.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }

    this.setState({
      snoozeDateForEntity: Time.weekFromDate(new Date())
    });
  }

  public componentWillUnmount() {
    this.setState({
      entity: null,
      isOpen: false,
      snoozeDateForEntity: Time.weekFromDate(new Date())
    })
  }

  public save = () => {
    if(!this.state.entity) {
      return;
    }

    switch(this.state.entity?.nameForUrl) {
      case "charge": 
        return this.snoozeCharge(this.state.entity);
      case "payment": 
        return this.snoozePayment(this.state.entity);
      case "statement": 
        return this.snoozeStatement(this.state.entity);  
      default:
        break; 
      }
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
    })
  }

  public snoozeCharge = (charge: ChargeInterface): any => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_SNOOZE_UPDATE_START,
        payload: {
          snoozeDate: !charge.isSnoozed ? Time.formatOrNull(this.state.snoozeDateForEntity) : null,
          chargeId: charge?.id
        },
        onSuccess: () => {
          this.setState({
            anchorEl: null,
            isSaving: false,
            snoozeDateForEntity: Time.weekFromDate(new Date())
          }, () => {
            if (this.props.fetchFirstUnpaidCharges) {
              this.props.fetchFirstUnpaidCharges();
            }
            this.props.closeDialog();
          })
        },
        onError: () => {
          this.setState({
            isSaving: false
          }, this.props.closeDialog);
        }
      });
    });
  }

  public snoozePayment = (payment: PaymentInterface): any => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_SNOOZE_UPDATE_START,
        payload: {
          snoozeDate: !payment.isSnoozed ? Time.formatOrNull(this.state.snoozeDateForEntity) : null,
          paymentId: payment?.id
        },
        onSuccess: () => {
          this.setState({
            anchorEl: null,
            isSaving: false,
          },() => {
            if (this.props.fetchFirstUnusedPayments) {
              this.props.fetchFirstUnusedPayments();
            }
            this.props.closeDialog();
          })
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  
  public snoozeStatement = (statement: FinancialStatementInterface) => {
    if(!statement) {
      return;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_STATEMENT_SNOOZE_UPDATE_START,
        payload: {
          snoozeDate: !statement.isSnoozed ? Time.formatOrNull(this.state.snoozeDateForEntity) : null,
          statementId: statement?.id
        },
        onSuccess: () => {
          this.setState({
            anchorEl: null,
            isSaving: false,
          },() => {
            if (this.props.fetchFirstNotSentStatements) {
              this.props.fetchFirstNotSentStatements();
            }
            this.props.closeDialog();

          })
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public render() {
    return (
      <PromptDialog
      {...this.props}
      openLeavePrompt={this.state.isOpen}
      title={this.trans("title-snooze-until")}
      content={
        <div style={{width: "220px"}}>
          <DatePickerComponent
            {...this.props}
            id="snoozeDateForEntity"
            name="snoozeDateForEntity"
            className="scroll-to-snoozeDateForEntity"
            label={this.trans("date")}
            initialDate={this.state.snoozeDateForEntity}
            onChange={date => this.selectDate(date, "snoozeDateForEntity")}
            minDate={new Date()}
            minDatePlusDays={1}
            error={this.getErrorFor("snoozeDateForEntity")}
          />
        </div>
      }
      positiveButtonLabel={this.trans("dialog-button/finish")}
      negativeButtonLabel={this.trans("dialog-button/cancel")}
      onSave={() => this.save()}
      onDiscard={() => this.props.closeDialog()}
    />
    );
  }
}
